module.exports = __webpack_public_path__ + "assets/images/hotel-02.e36b36d8f74820dca5d4224874b147fe.svg";